import React from 'react';
import { Fab, useTheme } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';

interface MobileShareFABProps {
  onClick: () => void;
}

const MobileShareFAB: React.FC<MobileShareFABProps> = ({ onClick }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Fab
      onClick={onClick}
      aria-label="Share heatmap"
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 1100,
        display: { xs: 'flex', md: 'none' },
        '@media (min-width: 768px)': { display: 'none' },
        bgcolor: isDark ? '#fff' : '#000',
        color: isDark ? '#000' : '#fff',
        boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        animation: 'fabEntry 0.4s cubic-bezier(0.22, 1, 0.36, 1) backwards 0.5s',
        '@keyframes fabEntry': {
          '0%': { opacity: 0, transform: 'scale(0.5)' },
          '100%': { opacity: 1, transform: 'scale(1)' },
        },
        '&:hover': { bgcolor: isDark ? '#e0e0e0' : '#333', boxShadow: '0 6px 20px rgba(0,0,0,0.25)' },
        '&:active': { transform: 'scale(0.92)' },
      }}
    >
      <ShareIcon />
    </Fab>
  );
};

export default MobileShareFAB;
